import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-mask w-full h-full" }
const _hoisted_2 = { class: "modal-container-form-model" }
const _hoisted_3 = { class: "modal-body pad-20" }
const _hoisted_4 = { class: "row w-full mtop-10" }
const _hoisted_5 = { class: "col-0-8 colend mright-04" }
const _hoisted_6 = { class: "main-m" }
const _hoisted_7 = { class: "row w-full mtop-10" }
const _hoisted_8 = { class: "col-0-8 colend mright-04" }
const _hoisted_9 = { class: "main-m" }
const _hoisted_10 = { class: "row w-full mtop-10" }
const _hoisted_11 = { class: "col-0-8 colend mright-04" }
const _hoisted_12 = { class: "main-m" }
const _hoisted_13 = { class: "row w-full mtop-10" }
const _hoisted_14 = { class: "col-0-8 colend mright-04" }
const _hoisted_15 = { class: "main-m" }
const _hoisted_16 = { class: "flex-row h-full gap-06 mtop-10 row-center" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "txt-warn" }

import { ref, computed, onMounted } from "vue";
import { useI18n } from 'vue-i18n';
import SharedService from "@/services/SharedService";
import Select from 'primevue/select';
import { useAppUserStore } from "@/stores/appUser";
import { toastError, toastSuccess } from "@/utils/toast-utils";
import { useToast } from "primevue";
import { ApiError } from "@/models/share.model";
import { InstituteAddress, InstituteApi, InstituteEmail, InstituteHeader, InstitutePhone, InstitutePreferencesRequest, InstitutePreferencesResponse, PersonApi } from "@/apiGenerate/medserver";
import { medServerApiConfig } from "@/config/medserver-api.config";
import { COUNTRY_LIST } from "@/functions/geo";


export default /*@__PURE__*/_defineComponent({
  __name: 'updateAccountInstitutePreferenceForm',
  props: {
    header: {},
    instituteId: {}
  },
  emits: ["modal-close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useI18n();
const toast = useToast();
const appUserStore = useAppUserStore();

const personApi = new PersonApi(medServerApiConfig);
const instituteApi = new InstituteApi(medServerApiConfig);

const instituteAddresses = ref<InstituteAddress[]>([]);
const instituteEmails = ref<InstituteEmail[]>([]);
const institutePhones = ref<InstitutePhone[]>([]);
const instituteHeaders = ref<InstituteHeader[]>([]);

const currentAddress = ref<InstituteAddress>(null);
const currentPhone = ref<InstitutePhone>(null);
const currentEmail = ref<InstituteEmail>(null);
const currentHeader = ref<InstituteHeader>(null);

const emit = __emit;

const currentHealthGroupMembershipRelashipId = computed(() => appUserStore.currentHealthGroupMembership?.relationshipId);

const currentPersonId = computed(() => {
  if (!appUserStore.currentAppUserData || !appUserStore.currentAppUserData.healthGroupMemberships) {return null}
  return appUserStore.currentAppUserData.healthGroupMemberships[0].pwr.personWithRoleId
});

const confirmFormModal = async () => {
  if (currentHealthGroupMembershipRelashipId.value && props.instituteId && currentPersonId.value) {
    const institutePreferencesRequest: InstitutePreferencesRequest = {
      instituteAddress: currentAddress.value ? currentAddress.value.addressId : null,
      instituteEmail: currentEmail.value ? currentEmail.value.instituteEmailId : null,
      institutePhone: currentPhone.value ? currentPhone.value.institutePhoneId : null,
      instituteHeader: currentHeader.value ? currentHeader.value.instituteHeaderId : null,
    }

    await personApi.updateInstitutePreferenceByPerson({instituteId: props.instituteId, personId: currentPersonId.value, institutePreferencesRequest: institutePreferencesRequest})
      .then(() => {
        toastSuccess(toast, {
        summary: t('common.toast.success.update'),
        detail:  t('settings.label.account.institute.preference.message.success')
      });
    }).catch((error: ApiError) => {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
        });
        // Throw error to set at false the var __alreadyClicked in v-one-click directive
        throw error;
    });
  }
  
  emit('modal-close', null);
}

const closeFormModal = () => {
  emit('modal-close');
}

const getCountryNameByISO = (iso: string) => {
  return COUNTRY_LIST.filter((country) => country.isoCode === iso)[0].term;
}

const getAddressesByInsitute = async () => {
  if (props.instituteId)
  await instituteApi.listAddressesByInstitute({ instituteId: props.instituteId }).then((res: InstituteAddress[]) => {
    instituteAddresses.value = res;
  }).catch((error: ApiError) => {
    toastError(toast, {
        summary: t('common.toast.error'),
        detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
    });
  });
};

const getEmailsByInsitute = async () => {
  if (props.instituteId)
  await instituteApi.listEmailsByInstitute({ instituteId: props.instituteId }).then((res: InstituteEmail[]) => {
    instituteEmails.value = res;
  }).catch((error: ApiError) => {
    toastError(toast, {
        summary: t('common.toast.error'),
        detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
    });
  });
};

const getPhonesByInsitute = async () => {
  if (props.instituteId)
  await instituteApi.listPhonesByInstitute({ instituteId: props.instituteId }).then((res: InstitutePhone[]) => {
    institutePhones.value = res;
  }).catch((error: ApiError) => {
    toastError(toast, {
        summary: t('common.toast.error'),
        detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
    });
  });
};

const getHeadersByInstitute = async () => {
  if (props.instituteId)
  await instituteApi.listHeadersByInstitute({ instituteId: props.instituteId }).then((res: InstituteHeader[]) => {
    instituteHeaders.value = res;
  }).catch((error: ApiError) => {
    toastError(toast, {
        summary: t('common.toast.error'),
        detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
    });
  });
};

onMounted(async () => {
  await getAddressesByInsitute();
  await getEmailsByInsitute();
  await getPhonesByInsitute();
  await getHeadersByInstitute();
  
  if (props.instituteId && currentPersonId.value)
  await personApi.findInstitutePreferenceByPerson({instituteId: props.instituteId, personId: currentPersonId.value}).then((result: InstitutePreferencesResponse) => {
    currentAddress.value = result.instituteAddress ? instituteAddresses.value.filter((institutedAdress) => institutedAdress.addressId === result.instituteAddress)[0] : undefined;
    currentEmail.value = result.instituteEmail ? instituteEmails.value.filter((email) => email.instituteEmailId === result.instituteEmail)[0] : undefined;
    currentPhone.value = result.institutePhone ? institutePhones.value.filter((phone) => phone.institutePhoneId === result.institutePhone)[0] : undefined;
    currentHeader.value = result.instituteHeader ? instituteHeaders.value.filter((h) => h.instituteHeaderId === result.instituteHeader)[0] : undefined;
  }).catch((error: ApiError) => {
    toastError(toast, {
        summary: t('common.toast.error'),
        detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
    });
  });
})

return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_es_modal_header, { header: _ctx.header }, null, 8, ["header"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('settings.label.account.institute.preference.address')), 1)
          ]),
          _createVNode(_unref(Select), {
            modelValue: currentAddress.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentAddress).value = $event)),
            options: instituteAddresses.value,
            optionLabel: "address.street",
            size: "small",
            showClear: "",
            editable: "",
            emptyMessage: _unref(t)('patient.search.noResult'),
            class: "w-full"
          }, {
            option: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.option.address.street + " " + slotProps.option.address.postalCode + " " + slotProps.option.address.locality + " " + getCountryNameByISO(slotProps.option.address.isoCode).toUpperCase()), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "options", "emptyMessage"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('settings.label.account.institute.preference.phone')), 1)
          ]),
          _createVNode(_unref(Select), {
            modelValue: currentPhone.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentPhone).value = $event)),
            options: institutePhones.value,
            optionLabel: "phoneNumber",
            size: "small",
            showClear: "",
            editable: "",
            emptyMessage: _unref(t)('patient.search.noResult'),
            class: "w-full"
          }, null, 8, ["modelValue", "options", "emptyMessage"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('settings.label.account.institute.preference.email')), 1)
          ]),
          _createVNode(_unref(Select), {
            modelValue: currentEmail.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentEmail).value = $event)),
            options: instituteEmails.value,
            optionLabel: "email",
            size: "small",
            showClear: "",
            editable: "",
            emptyMessage: _unref(t)('patient.search.noResult'),
            class: "w-full"
          }, null, 8, ["modelValue", "options", "emptyMessage"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('settings.label.account.institute.preference.headerLines')), 1)
          ]),
          _createVNode(_unref(Select), {
            modelValue: currentHeader.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentHeader).value = $event)),
            options: instituteHeaders.value,
            optionLabel: "customLine1",
            size: "small",
            showClear: "",
            editable: "",
            emptyMessage: _unref(t)('patient.search.noResult'),
            class: "w-full"
          }, {
            option: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.option.customLine1 + (slotProps.option.customLine2 ? ' — ' + slotProps.option.customLine2 : '')), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "options", "emptyMessage"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("img", {
            src: _unref(SharedService).getIcon('exclamationmark-triangle', true, 'shareIcons'),
            class: "img-warn icon-container"
          }, null, 8, _hoisted_17),
          _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(t)('settings.label.account.institute.preference.warning')), 1)
        ])
      ]),
      _createVNode(_component_es_modal_footer, {
        onModalCancel: closeFormModal,
        confirmModalMethod: () => confirmFormModal(),
        confirmLabel: 'action.save'
      }, null, 8, ["confirmModalMethod"])
    ])
  ]))
}
}

})